export default "__VITE_PUBLIC_ASSET__61f6eb11__"